export const pipe = (...fns) => (source) => fns.reduce((request, fn) => fn(request), source);
